import { render, staticRenderFns } from "./AccordionIcon.vue?vue&type=template&id=4a77e106"
import script from "./AccordionIcon.vue?vue&type=script&lang=js"
export * from "./AccordionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports